<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.67923 19.65C10.2786 20.179 11.0659 20.5 11.9282 20.5C12.7905 20.5 13.5778 20.179 14.1771 19.65M17.0282 8.6C17.0282 7.2474 16.4909 5.95019 15.5344 4.99376C14.578 4.03732 13.2808 3.5 11.9282 3.5C10.5756 3.5 9.27837 4.03732 8.32193 4.99376C7.3655 5.95019 6.82818 7.2474 6.82818 8.6C6.82818 11.2267 6.16558 13.0251 5.42539 14.2146C4.80104 15.218 4.48886 15.7197 4.5003 15.8596C4.51298 16.0146 4.54581 16.0737 4.67069 16.1663C4.78347 16.25 5.29188 16.25 6.3087 16.25H17.5477C18.5645 16.25 19.0729 16.25 19.1857 16.1663C19.3105 16.0737 19.3434 16.0146 19.3561 15.8596C19.3675 15.7197 19.0553 15.218 18.431 14.2146C17.6908 13.0251 17.0282 11.2267 17.0282 8.6Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
